export enum RoomConfiguration {
  EXTERNAL_VIEW = 'externalView',
  INTERNAL_VIEW = 'internalView',
}

export enum RoomFeature {
  BOARD_ROOM = 'boardRoom',
  CABARET = 'cabaret',
  CLASSROOM = 'classroom',
  DATA = 'data',
  THEATRE = 'theatre',
  U_SHAPE = 'uShape'
}

export interface RoomFilterParams {
  roomPosition?: string;
  roomType?: string;
}

export interface RoomFilterCriteria {
  roomConfiguration?: RoomConfiguration;
  roomFeature?: RoomFeature;
}

export interface FilterFormValue {
  view: string;
  feature: string;
}

export const ROOM_POSITION_MAP: Record<RoomConfiguration, string[]> = {
  [RoomConfiguration.INTERNAL_VIEW]: ['Interior'],
  [RoomConfiguration.EXTERNAL_VIEW]: ['Exterior', 'StunningView'],
};

export const ROOM_TYPE_MAP: Record<RoomFeature, string> = {
  [RoomFeature.BOARD_ROOM]: 'MRBoardroom',
  [RoomFeature.CABARET]: 'MRCabaret',
  [RoomFeature.CLASSROOM]: 'MRClassroom',
  [RoomFeature.DATA]: 'MRData',
  [RoomFeature.THEATRE]: 'MRTheater',
  [RoomFeature.U_SHAPE]: 'MRUShaped',
};

export const REVERSE_ROOM_POSITION_MAP: Record<string, RoomConfiguration> = {
  'Interior': RoomConfiguration.INTERNAL_VIEW,
  'Exterior,StunningView': RoomConfiguration.EXTERNAL_VIEW,
};

export const REVERSE_ROOM_TYPE_MAP: Record<string, RoomFeature> = Object.fromEntries(
  Object.entries(ROOM_TYPE_MAP).map(([k, v]) => [v, k as RoomFeature])
);


